import { render, staticRenderFns } from "./PuntoDeVentaUbicacionesListado.vue?vue&type=template&id=e5d55124"
import script from "./PuntoDeVentaUbicacionesListado.vue?vue&type=script&lang=js"
export * from "./PuntoDeVentaUbicacionesListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports